// Event wrapper that prevents any mouse event that is a right click from
// firing `next`
export default function (next, e, allowCtrl) {
  if (/^mouse/.test(e.type) && e.which === 1) {
    // Normally prevent ctrlKey + click (which simulates right clicks), unless `allowCtrl` is true
    if (!e.ctrlKey || allowCtrl) {
      return next.apply(this, [e])
    }
  }
  if (/^touch/.test(e.type)) {
    return next.apply(this, [e])
  }
}
